import React, { useEffect, useState, useRef } from "react";
import { useLocation } from "react-router-dom";
import FormUser from "./FormUser";
import FormAddress from "./FormAddess";
import FormAirport from "./FormAirport";

import { getPaxData, sommePax } from "../../utils/paxUtils";
import { fetchPrices, calculateShuttlePrices, calculatePrivatePrices, calculateShuttlePricesPax, calculatePrivatePricesPax } from "../../utils/priceUtils";
import usePriceCalculation from "../../hooks/usePriceCalculation";
import { formatHeureMinute } from "../../utils/formatDateHeure";
import { debugLogger } from "../../utils/LogDebug";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { addDays, addYears } from "date-fns";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarAlt } from "@fortawesome/free-solid-svg-icons";

// import { isValidNumber } from "libphonenumber-js";
import validatePhoneNumber from "../../utils/validatePhoneNumber";

import "./Reservation.css";

const confirmeResaPhp = process.env.REACT_APP_CONFIRME_RESERVATION_URL || "/api/confirme_resa.php";

const ReservationForm = () => {
    const location = useLocation();

    const [isBooking, setIsBooking] = useState(true);
    const [errorBookingFields, setErrorBookingFields] = useState([]);

    const [shuttleData, setShuttleData] = useState([]);
    const [privateData, setPrivateData] = useState([]);
    const [prices, setPrices] = useState({});


    const queryParams = new URLSearchParams(location.search);

    const from = (queryParams.get("depart") || "").replace(/_/g, " ");
    const to = (queryParams.get("arrive") || "").replace(/_/g, " ");

    
    var delai_minimum_reservation = 20; // Impossible de reserver 20h avant le départ
     
    var shuttleHeureTakeOffMinH = 8;
    var shuttleHeureTakeOffMinM = 0;
    var shuttleHeureTakeOffMaxH = 23;
    var shuttleHeureTakeOffMaxM = 45;

    var shuttleHeureLandingMinH = 4;
    var shuttleHeureLandingMinM = 30;
    var shuttleHeureLandingMaxH = 22;
    var shuttleHeureLandingMaxM = 0;

    var privateHeureTakeOffMinH = 8;
    var privateHeureTakeOffMinM = 0;
    var privateHeureTakeOffMaxH = 23;
    var privateHeureTakeOffMaxM = 45;

    var privateHeureLandingMinH = 4;
    var privateHeureLandingMinM = 30;
    var privateHeureLandingMaxH = 23;
    var privateHeureLandingMaxM = 0;
    
    const getMinMaxTime = (type, reservationData) => {
        const isShuttle = reservationData.shuttle_private === "Shuttle";
    
        return {
            minH: type === "drop" 
                ? (isShuttle ? reservationData.shuttleHeureTakeOffMinH : reservationData.privateHeureTakeOffMinH)
                : (isShuttle ? reservationData.shuttleHeureLandingMinH : reservationData.privateHeureLandingMinH),
    
            minM: type === "drop" 
                ? (isShuttle ? reservationData.shuttleHeureTakeOffMinM : reservationData.privateHeureTakeOffMinM)
                : (isShuttle ? reservationData.shuttleHeureLandingMinM : reservationData.privateHeureLandingMinM),
    
            maxH: type === "drop" 
                ? (isShuttle ? reservationData.shuttleHeureTakeOffMaxH : reservationData.privateHeureTakeOffMaxH)
                : (isShuttle ? reservationData.shuttleHeureLandingMaxH : reservationData.privateHeureLandingMaxH),
    
            maxM: type === "drop" 
                ? (isShuttle ? reservationData.shuttleHeureTakeOffMaxM : reservationData.privateHeureTakeOffMaxM)
                : (isShuttle ? reservationData.shuttleHeureLandingMaxM : reservationData.privateHeureLandingMaxM),
        };
    };
    
    // Initialize reservation data
    const initialReservation = {
        // Basic Information
        shuttle_private: queryParams.get("private_shuttle") === "1" ? "Private" : "Shuttle",
        lastname: "", // "JASMIN",
        firstname: "", // "Maurice",
        phone: "", // "+",
        phoneHome: "",
        phone_mobile: "",
        phoneMobile: "", // "+33663603438", // "",
        fax_number: "",
        email: "", // "mj@m-j.fr",
        address: "", // "1 allée des Poiriers",
        postcode: "", // "95400",
        city: "", // "Villiers Le Bel",
        country: "", // "FR",
        phoneCountryCode: "", // "fr",
        phoneCountryName: "", // "france",
        phoneCountryFormat: "", // "+.. . .. .. .. ..",
        nb_trajet: queryParams.get("type_trajet") === "2" ? 2 : 1, // Number of trips

        // Passenger Info
        nb_pax: getPaxData(queryParams.get("nb_pax")),
        aller_retour: queryParams.get("type_trajet") === "2" ? 2 : 1, // Round trip

        duree_aller: 45,
        duree_retour: 45,
        delai_depart: 30,
        delai_arrive: 135,

        depart: from, // Updated
        arrive: to,   // Updated

        // luggage
        stroller_single: 0,
        stroller_double: 0,
        cabin_bag: 1,
        check_in_luggage: 1,

        // Price
        prix_cash: 0,
        prix_cb: 0,

        // Trip 1 Fields
        date_pu_t1: null, //"",
        french_date_pu_t1: null, //"",
        date_jour_pu_t1: null, //"",
        date_mois_pu_t1: null, //"",
        date_annee_pu_t1: null, //"",
        time_h_pu_t1: "",
        time_m_pu_t1: "",
        pax_t1: getPaxData(queryParams.get("nb_pax")).total,
        pax_adult_t1: getPaxData(queryParams.get("nb_pax")).adults,
        pax_child_t1: getPaxData(queryParams.get("nb_pax")).children,
        pax_baby_t1: 0,
        lieu_pu_t1: from,
        type_pu_t1: parseInt(queryParams.get("depart_type")),
        horaire_vol_pu_t1: "", // "14:45",
        time_vol_pu_t1: "", // "15",
        minute_vol_pu_t1: "", // "45",
        city_vol_pu_t1: "", // "City Vol",
        num_vol_pu_t1: "", // "Vol",
        hotel_pu_t1: "", // "Hotel",
        hotel_n_pu_t1: "", // "13",
        address_pu_t1: "", // "Adress PU",
        zip_pu_t1: "", // "75015",
        lieu_drop_t1: to,
        type_drop_t1: queryParams.get("arrive_type"),
        horaire_vol_drop_t1: "", // "20:29",
        time_vol_drop_t1: "", // "20",
        minute_vol_drop_t1: "", // "29",
        city_vol_drop_t1: "", // "City Drop",
        num_vol_drop_t1: "", // "NomVol Drop",
        hotel_drop_t1: "", // "Hotel drop",
        hotel_n_drop_t1: "", // "Hotel Num",
        address_drop_t1: "", // "Address Dop",
        zip_drop_t1: "", // "75018",
        prix_t1: "",
        duree_t1: "",
        info_t1: "", // "TEST DE MAURICE info T1",

        // Trip 2 Fields (if round trip)
        date_pu_t2: null, //"",
        french_date_pu_t2: null, //"","",
        date_jour_pu_t2: null, //"","",
        date_mois_pu_t2: null, //"","",
        date_annee_pu_t2: null, //"","",
        time_h_pu_t2: "",
        time_m_pu_t2: "",
        pax_t2: getPaxData(queryParams.get("nb_pax")).adults,
        pax_adult_t2: getPaxData(queryParams.get("nb_pax")).adults,
        pax_child_t2: getPaxData(queryParams.get("nb_pax")).children,
        pax_baby_t2: 0,
        lieu_pu_t2:  to,
        type_pu_t2: queryParams.get("arrive_type"),
        horaire_vol_pu_t2: "", // "20:39",
        time_vol_pu_t2: "",
        minute_vol_pu_t2: "",
        city_vol_pu_t2: "",
        num_vol_pu_t2: "",
        hotel_pu_t2: "",
        hotel_n_pu_t2: "",
        address_pu_t2: "",
        zip_pu_t2: "",
        lieu_drop_t2: from || "",
        type_drop_t2: queryParams.get("depart_type"),
        horaire_vol_drop_t2: "", // "20:40",
        time_vol_drop_t2: "",
        minute_vol_drop_t2: "",
        city_vol_drop_t2: "",
        num_vol_drop_t2: "",
        hotel_drop_t2: "",
        hotel_n_drop_t2: "",
        address_drop_t2: "",
        zip_drop_t2: "",
        prix_t2: "",
        duree_t2: "",
        info_t2: "", // "TEST DE MAURICE T2",

        info_pax_luggage: "PAX LUGGAGE",

        // Controles
        delai_minimum_reservation: delai_minimum_reservation, // en heures

        shuttleHeureTakeOffMinH: shuttleHeureTakeOffMinH,
        shuttleHeureTakeOffMinM: shuttleHeureTakeOffMinM,
        shuttleHeureTakeOffMaxH: shuttleHeureTakeOffMaxH,
        shuttleHeureTakeOffMaxM: shuttleHeureTakeOffMaxM,

        shuttleHeureLandingMinH: shuttleHeureLandingMinH,
        shuttleHeureLandingMinM: shuttleHeureLandingMinM,
        shuttleHeureLandingMaxH: shuttleHeureLandingMaxH,
        shuttleHeureLandingMaxM: shuttleHeureLandingMaxM,

        privateHeureTakeOffMinH: privateHeureTakeOffMinH,
        privateHeureTakeOffMinM: privateHeureTakeOffMinM,
        privateHeureTakeOffMaxH: privateHeureTakeOffMaxH,
        privateHeureTakeOffMaxM: privateHeureTakeOffMaxM,

        privateHeureLandingMinH: privateHeureLandingMinH,
        privateHeureLandingMinM: privateHeureLandingMinM,
        privateHeureLandingMaxH: privateHeureLandingMaxH,
        privateHeureLandingMaxM: privateHeureLandingMaxM,

        cp_depart: [],
        cp_arrive: [],

    };

    const [reservationData, setReservationData] = useState(initialReservation);

    // Utilisation du Hook en passant reservationData et setReservationData
    const { pricePax, calculatePrice } = usePriceCalculation(reservationData, setReservationData);


const fieldRefs = {
    lastname: useRef(null),
    firstname: useRef(null),
    phoneMobile: useRef(null),
    email: useRef(null),
    address: useRef(null),
    postcode: useRef(null),
    city: useRef(null),
    country: useRef(null),

    pax_adult_t1: useRef(null),

    french_date_pu_t1: useRef(null),
    
    french_date_pu_t2: useRef(null),

    info_t1: useRef(null),
    info_t2: useRef(null),

    horaire_vol_pu_t1: useRef(null),
    horaire_vol_drop_t1: useRef(null),
    
    horaire_vol_pu_t2: useRef(null),
    horaire_vol_drop_t2: useRef(null),
};

const validateReservation = (t1t2 = "") => {
    // debugLogger.log("AUTOMATIQUE validateReservation " + t1t2 + " nb_trajet=" + reservationData.nb_trajet);

    let validationErrorsFields = [];

    if (t1t2 === "") {
        if (reservationData.nb_trajet === 1) {
            setErrorBookingFields([]);
            const errorsT1 = validateReservation("t1");
            return errorsT1;
        }
        if (reservationData.nb_trajet === 2) {
            setErrorBookingFields([]);
            const errorsT1 = validateReservation("t1");
            const errorsT2 = validateReservation("t2");
            return [...errorsT1, ...errorsT2]; // Fusionner les erreurs
        }
        return;
    }

    const addError = (message, fieldId) => {
        validationErrorsFields.push({ message, fieldId });
    };

    let step = "USER - ";
// debugLogger.log({"phoneMobile":reservationData.phoneMobile, "length":reservationData.phoneMobile.length});
    if (t1t2 === "t1") {
        // Vérifier que tous les champs obligatoires sont remplis
        if (!reservationData.lastname) addError(step + "Please enter your <b>last name</b>.", `lastname`);
        if (!reservationData.firstname) addError(step + "Please enter your <b>first name</b>.", `firstname`);
        // if (!reservationData.phoneMobile) addError(step + "Please enter your phone number. AZ", `firstname`); // car phoneMobile ne fonctionne pas
        if (!reservationData.email) addError(step + "Please enter a valid <b>email</b>.", `email`);
        // if (!reservationData.address) addError(step + "Please enter a valid address.", `address`);
        // if (!reservationData.postcode) addError(step + "Please enter a valid postcode.", `postcode`);
        // if (!reservationData.city) addError(step + "Please enter a valid city.", `city`);
        // if (!reservationData.country) addError(step + "Please enter a valid country.", `country`);
        if (!reservationData.pax_adult_t1) addError(step + "Please enter a minimun <b>adult pax</b>.", `pax_adult_t1`);


        // Vérifier le numéro de téléphone
        if (reservationData.phoneMobile.length < 5) addError(step + "Please enter your <b>phone number</b>.", `firstname`); // car phoneMobile ne fonctionne pas
        else 
        {

            const phoneValidation = validatePhoneNumber(reservationData.phoneMobile, {
                countryCode: reservationData.phoneCountryCode,
                format: reservationData.phoneCountryFormat,
                name: reservationData.phoneCountryName,
            });
            // debugLogger.log(phoneValidation);
            if (!phoneValidation.isValid) {
                addError(step + phoneValidation.error, "firstname");
            } else {
                reservationData.phoneMobile = phoneValidation.phone; // Met à jour avec le bon format
            }
        }
    }


    if (t1t2 === "t1") { step = "FIRST STEP - ";}
    if (t1t2 === "t2") { step = "SECOND STEP - ";}
    if (!reservationData?.[`french_date_pu_${t1t2}`]) addError(step + ` Date Departure (${t1t2}) is required.`, `french_date_pu_${t1t2}`);
    // if (!reservationData?.[`lieu_pu_${t1t2}`]) addError(step + `Departure location (${t1t2}) is required.`, `lieu_pu_${t1t2}`);
    // if (!reservationData?.[`lieu_drop_${t1t2}`]) addError(step + `Arrival location (${t1t2}) is required.`, `lieu_drop_${t1t2}`);
    // if (!reservationData?.[`info_${t1t2}`]) addError('INFO ' + ` (${t1t2}) is required.`, `info_${t1t2}`);


    // Vérifier le délai minimum de réservation
    const now = new Date();
    const departureDate = new Date(
        reservationData[`date_annee_pu_${t1t2}`], 
        reservationData[`date_mois_pu_${t1t2}`] - 1, 
        reservationData[`date_jour_pu_${t1t2}`]
    );


    const diffHours = (departureDate - now) / (1000 * 60 * 60);

    if (diffHours < delai_minimum_reservation) {
        addError(step + ` Reservation must be made at least ${delai_minimum_reservation} hours before departure.`, `horaire_vol_pu_${t1t2}`);
    }


    // Vérifier le nombre de passagers
    if (!reservationData.nb_pax || reservationData.nb_pax <= 0) {
        addError(step + " pax_adult_t1 Number of passengers must be at least 1.", `pax_adult_t1`);
    }

    // Vérifier les horaires de vol pour le départ
    if (reservationData?.[`horaire_vol_pu_${t1t2}`]) {
        const [h, m] = reservationData[`horaire_vol_pu_${t1t2}`].split(":").map(Number);
        // debugLogger.log({ h, m, "Min": `${shuttleHeureTakeOffMinH}:${shuttleHeureTakeOffMinM}` });

        // Récupérer les horaires min et max en fonction du type de vol et du mode (Shuttle/Private)
        const { minH, minM, maxH, maxM } = getMinMaxTime("pu", reservationData);
        if (
            h < minH || 
            (h === minH && m < minM) || 
            h > maxH || 
            (h === maxH && m > maxM)
        ) {
            const horaireMinTakeOff = formatHeureMinute(60 * minH + minM);
            const horaireMaxTakeOff = formatHeureMinute(60 * maxH + maxM);

            addError(
                step + ` <b>Landing flight time</b> must be between ${horaireMinTakeOff} and ${horaireMaxTakeOff}. You entered: ` + reservationData[`horaire_vol_pu_${t1t2}`], 
                `horaire_vol_pu_${t1t2}`
            );
        }
    // } else {
    //     addError(step + "horaire_vol_pu_ Please enter a valid departure flight time.", `horaire_vol_pu_${t1t2}`);
    }

    // Vérifier les horaires de vol pour l'atterrissage
    if (reservationData?.[`horaire_vol_drop_${t1t2}`]) {
        const [h, m] = reservationData[`horaire_vol_drop_${t1t2}`].split(":").map(Number);

        // Récupérer les horaires min et max pour le landing
        const { minH, minM, maxH, maxM } = getMinMaxTime("drop", reservationData);

        if (
            h < minH || 
            (h === minH && m < minM) || 
            h > maxH || 
            (h === maxH && m > maxM)
        ) {
            const horaireMinLanding = formatHeureMinute(60 * minH + minM);
            const horaireMaxLanding = formatHeureMinute(60 * maxH + maxM);

            addError(
                step + ` <b>Departure flight time</b> must be between ${horaireMinLanding} and ${horaireMaxLanding}. You entered: ` + reservationData[`horaire_vol_drop_${t1t2}`], 
                `horaire_vol_drop_${t1t2}`
            );
        }
    // } else {
    //     addError(step + " Please enter a valid landing flight time.", `horaire_vol_drop_${t1t2}`);
    }


    // Vérification du délai entre pickup et drop-off
// debugLogger.log({"time_vol_pu_":   reservationData[`time_vol_pu_${t1t2}`],   "minute_vol_pu_": reservationData[`minute_vol_pu_${t1t2}`]});
// debugLogger.log({"time_vol_drop_": reservationData[`time_vol_drop_${t1t2}`], "minute_vol_drop_": reservationData[`minute_vol_drop_${t1t2}`]});
// debugLogger.log("t1t2="+t1t2);
// debugLogger.log(
//     " delai_depart_ =" + parseInt(reservationData[`delai_depart_${t1t2}`] || 0) +
//     " duree_" + parseInt(reservationData[`duree_${t1t2}`] || 0) +
//     " delai_arrive_" + parseInt(reservationData[`delai_arrive_${t1t2}`] || 0)
// );
    // debugLogger.log({
    //             "type_pu_": reservationData[`type_pu_${t1t2}`], 
    //             "type_drop_": reservationData[`type_drop_${t1t2}`], 
    //         })
    if (parseInt(reservationData[`type_pu_${t1t2}`]) === 1 && parseInt(reservationData[`type_drop_${t1t2}`]) === 1) {
        let vol_pu_en_minutes =
            parseInt(reservationData[`time_vol_pu_${t1t2}`] || 0) * 60 +
            parseInt(reservationData[`minute_vol_pu_${t1t2}`] || 0);
// debugLogger.log("vol_pu_en_minutes " + vol_pu_en_minutes + " " + formatHeureMinute(vol_pu_en_minutes));
        let vol_drop_en_minutes =
            parseInt(reservationData[`time_vol_drop_${t1t2}`] || 0) * 60 +
            parseInt(reservationData[`minute_vol_drop_${t1t2}`] || 0);
            
// debugLogger.log("vol_drop_en_minutes " + vol_drop_en_minutes + " " + formatHeureMinute(vol_drop_en_minutes));
        let delai =
            parseInt(reservationData[`delai_depart_${t1t2}`] || 0) +
            parseInt(reservationData[`duree_${t1t2}`] || 0) +
            parseInt(reservationData[`delai_arrive_${t1t2}`] || 0);
// debugLogger.log("delai " + delai + " "+ formatHeureMinute(delai));
        if (vol_drop_en_minutes - vol_pu_en_minutes < delai) {
            let text_delai = "The delay between pickup and drop-off is insufficient.";
            // text_delai += `<br> delay Pickup: ` + formatHeureMinute(reservationData[`delai_arrive_${t1t2}`]); 
            // text_delai += `<br> Trip duration: ` + formatHeureMinute(reservationData[`duree_${t1t2}`]); 
            // text_delai += `<br> delay Drop-off: ` + formatHeureMinute(reservationData[`delai_depart_${t1t2}`]); 
            text_delai += `<br> Time needed: ` + formatHeureMinute(delai);

            if (reservationData.nb_trajet === 2) {
                text_delai = "<b>from " + reservationData[`lieu_pu_${t1t2}`] + " to " + reservationData[`lieu_drop_${t1t2}`] + "</b><p>" + text_delai + "</p>";
            }
            // text_delai += "<p>horaire_vol_pu_ " + t1t2 + ' ' + reservationData[`horaire_vol_pu_${t1t2}`] + " to " + reservationData[`lieu_pu_${t1t2}`] + "<p>";
            // text_delai += "<p>horaire_vol_drop_ " + t1t2 + ' ' + reservationData[`horaire_vol_drop_${t1t2}`] + " to " + reservationData[`lieu_drop_${t1t2}`] + "<p>";
            // text_delai += "<p>if (" + vol_drop_en_minutes + '  - ' + vol_pu_en_minutes  + ")= "+ parseInt(vol_drop_en_minutes - vol_pu_en_minutes) + "< " + delai + "<p>";
           
            addError(step + text_delai, `horaire_vol_pu_${t1t2}`);
        }
    }

    // Mise à jour des erreurs en les accumulant
    if (validationErrorsFields.length !== 0) {
        setErrorBookingFields((prev) => [...prev, ...validationErrorsFields]);
    }

    // Mise à jour de l'état du bouton de réservation
    if (reservationData.nb_trajet === 1 || (reservationData.nb_trajet === 2 && t1t2 === "t2")) {
        setIsBooking(validationErrorsFields.length === 0);
    }



    return validationErrorsFields;
};


    // Charger et analyser le CSV
    // La première fois
    useEffect(() => {
console.log('DEBUT fetchPrices CSV ',reservationData.shuttle_private, reservationData.nb_pax, reservationData.nb_trajet, from, to);
        fetchPrices()
        .then(({ shuttles, privates }) => {
            let priceCalculated = null;
            if(reservationData.shuttle_private === "Shuttle"){

                debugLogger.log("Lecture des shuttles");
                console.log("fetchPrices renvoie shuttles", reservationData.shuttle_private, shuttles);
                setShuttleData(shuttles);
    
                priceCalculated = calculateShuttlePricesPax(shuttles, from, to, reservationData.nb_pax, reservationData.nb_trajet);
            }
            if(reservationData.shuttle_private === "Private"){
                // console.log('fetchPrices renvoie privates', reservationData.shuttle_private, privates);
                debugLogger.log("Lecture des Privates");
                setPrivateData(privates);
                priceCalculated = calculatePrivatePricesPax(privates, from, to, reservationData.nb_pax, reservationData.nb_trajet);

            }

            if (priceCalculated) {
                calculatePrice(priceCalculated); // Mise à jour du prix dans le Hook // Mise à jour des prix et des délais/duré
                // debugLogger.log({"First": priceCalculated });

            } else {
                console.warn("Aucun prix calculé, vérifiez les paramètres !");
            }

        })
        .catch((error) => {
            console.error("Error fetching CSV dans Reservation:", error);
        });

// console.log('FIN fetchPrices CSV ',reservationData.shuttle_private);
    }, [reservationData.shuttle_private]); // Ajouter from et to comme dépendances pour s'assurer que le useEffect s'exécute lorsque ces valeurs changent



    useEffect(() => {

console.log(' useEffect de shuttleData, privateData ', from, to, shuttleData, privateData, reservationData.nb_pax, reservationData.nb_trajet);
        let priceCalculated = null;
        // if (from && to && shuttleData.length > 0) {
        if (shuttleData.length > 0) {
            if(reservationData.shuttle_private === "Shutlle"){
                const shuttlePrices = calculateShuttlePrices(shuttleData, from, to);
                // console.log('calculateShuttlePrices shuttlePrices',shuttlePrices);
                setPrices({ shuttle: shuttlePrices });
                priceCalculated = calculateShuttlePricesPax(shuttleData, from, to, reservationData.nb_pax, reservationData.nb_trajet);
            }
        }
        if (privateData.length > 0) {
            if(reservationData.shuttle_private === "Pricate"){
                const privatePrices = calculatePrivatePrices(privateData, from, to);
                setPrices({ private: privatePrices });
                priceCalculated = calculatePrivatePricesPax(privateData, from, to, reservationData.nb_pax, reservationData.nb_trajet);
            }
console.log('    FIN MIS A JOUR DES PRIX priceCalculated ',priceCalculated);
            
        }
        else
            console.log('FICHIER PAS ENCORE CHARGE LES PRIVATES');
        if(priceCalculated)
        {
            calculatePrice(priceCalculated); // Mise à jour des prix et des délais/duré

            debugLogger.log({"Mise à jour": priceCalculated });
        }

    }, [shuttleData, privateData]); // Ajouter toutes les dépendances nécessaires

  
    const handleDateChange = (t1t2, date) => {
        debugLogger.log("DANS handleDateChange " + String(t1t2) + " " + String(date));
    
        if (!date) {
            debugLogger.log("DATE EST NULLE ---------------------------------");
            setIsBooking(false);
            return;
        }
        debugLogger.log("LA DATE N'EST pas NULLE ");
        // Extraction des valeurs de la date
        const day = date.getDate();  // Stocké en `Number`
        const month = date.getMonth() + 1;
        const year = date.getFullYear();
    
        const french_date = `${String(day).padStart(2, "0")}/${String(month).padStart(2, "0")}/${year}`;
    
        debugLogger.log({
            day, month, year, french_date
        });

        setReservationData((prev) => ({
            ...prev,
            [`date_jour_pu_${t1t2}`]: parseInt(day),  // Stocké en `Number`
            [`date_mois_pu_${t1t2}`]: month,
            [`date_annee_pu_${t1t2}`]: year,
            [`french_date_pu_${t1t2}`]: french_date,
            [`date_pu_${t1t2}`]: french_date
        }));

        validateReservation();
    
        // Attendre la mise à jour de l'état avant de valider
        // setTimeout(() => {
        //     validateReservation();
        // }, 100);
    };

 const handlePhoneChange = (value, country) => {
        // debugLogger.log({"country":country})
        // debugLogger.log({"reservationData.phoneCountryCode":reservationData.phoneCountryCode})
        // debugLogger.log({"reservationData.phoneMobile":reservationData.phoneMobile})

        const phoneInternational = "+" + value;
        setReservationData((prev) => ({
            ...prev,
            phoneMobile: phoneInternational,
            phoneHome: phoneInternational,
            phone: phoneInternational,
            phone_mobile: phoneInternational,
            phoneCountryCode: country.countryCode.toUpperCase(),
            phoneCountryFormat: country.format,
            phoneCountryName: country.name,
        }));

        // phoneCountry
        const validation = validatePhoneNumber(value, country);
        // debugLogger.log({"validation":validation});
        
        if (validation.isValid) {
            // debugLogger.log("------YOUPI-----");
            // setIsPhoneValid(false);
            return;
        }
 
    };

    const handleCountryChange = (selectedOption) => {
        setReservationData((prev) => ({
            ...prev,
            country: selectedOption.value,
        }));
        // debugLogger.log({country: selectedOption.value});
    };

    const prevTypePuT1 = useRef(null); // Stocke l'ancienne valeur

    useEffect(() => {
        if (prevTypePuT1.current !== null) { // Vérifie qu'on n'est pas à la première exécution
            // debugLogger.logDetail(`CHANGEMENT DE type_pu_t1 : ${prevTypePuT1.current} → ${reservationData.type_pu_t1}`, true);
        }
    
        // Met à jour la valeur précédente après chaque rendu
        prevTypePuT1.current = reservationData.type_pu_t1;

    },[reservationData.type_pu_t1])


    // Universal handler for all form fields
    const handleChange = (event) => {
        const { id, name, value } = event.target; // Extract id, name, and value
        const field = id || name; // Use `id` as the field name, fallback to `name`

        // Cas général
        setReservationData((prev) => ({
            ...prev,
            [field]: value,
        }));

debugLogger.log({[field]: value});

        // Vérifier si c'est un champ time_vol_drop_Tx (par exemple: time_vol_drop_t1)
        // ou time_vol_pu_t1
        if (field.startsWith("horaire_vol_")) {
            const [hours, minutes] = value.split(":"); // Séparer HH:MM

            // Arrondir les minutes au palier de 15 minutes le plus proche
            let minute15 = Math.round(minutes / 15) * 15;
            if (minute15 === 60) {
                // minutes = 0;
                // hours = (hours + 1) % 24; // Passer à l'heure suivante si 60 minutes
                minute15 = 45;
            }
            const horaire = hours + ":" + minute15;
 debugLogger.log({[field]: horaire});
 const formattedTime = `${String(hours).padStart(2, "0")}:${String(minute15).padStart(2, "0")}`;
//  event.target.value = formattedTime;



            // Extraire le type du trajet (pu ou drop) et le numéro du trajet (t1 ou t2)
            const separatedField = field.split("_");
            const PuDrop_Tx = separatedField.slice(-2).join("_");

            // On extrait t1 ou t2 avec PuDrop_Tx, puis on crée minute_vol_drop_t1
            setReservationData((prev) => ({
                ...prev,
                // [field]: value, // Stocker l'heure complète "HH:MM"
                [field]: formattedTime,
                [`time_vol_${PuDrop_Tx}`]: hours, // Stocker les heures
                [`minute_vol_${PuDrop_Tx}`]: minute15, // Stocker les heures
                }));
                /*
            setReservationData((prev) => {
                const updatedData = {
                    ...prev,
                    [field]: value, // Stocker l'heure complète "HH:MM"
                    [`time_vol_${PuDrop_Tx}`]: hours, // Stocker les heures
                    [`minute_vol_${PuDrop_Tx}`]: minutes, // Stocker les minutes
                };
                
                debugLogger.log("Mise à jour immédiate", updatedData); // Ici, on voit bien les nouvelles valeurs
                return updatedData;
            });
            */
            

            /*
            debugLogger.log({
                [field]: "AVANT " + value,
                [`time_vol_${PuDrop_Tx}`]: hours, // Stocker les heures
                [`minute_vol_${PuDrop_Tx}`]: minutes, // Stocker les minutes
            });
            debugLogger.log({
                [field]: "APRES " +value,
                [`time_vol_${PuDrop_Tx}`]: reservationData[`time_vol_${PuDrop_Tx}`], // Stocker les heures
                [`minute_vol_${PuDrop_Tx}`]: reservationData[`minute_vol_${PuDrop_Tx}`], // Stocker les minutes
            });
            */
        }
        // passagers géré dans le useEffet

        // mets à jour les données du retour
        if(reservationData.nb_trajet === 2) {

            const fieldReturn = [
                { filedT1: 'pax_t1', fieldT2: 'pax_t2' },
                { filedT1: 'pax_adult_t1', fieldT2: 'pax_adult_t2' },
                { filedT1: 'pax_child_t1', fieldT2: 'pax_child_t2' },
                { filedT1: 'pax_baby_t1', fieldT2: 'pax_baby_t2' },
                { filedT1: 'lieu_pu_t1', fieldT2: 'lieu_drop_t2' },
                { filedT1: 'lieu_drop_t1', fieldT2: 'lieu_pu_t2' },
                { filedT1: 'address_pu_t1', fieldT2: 'address_drop_t2' },
                { filedT1: 'address_drop_t1', fieldT2: 'address_pu_t2' },
                { filedT1: 'zip_pu_t1', fieldT2: 'zip_drop_t2' },
                { filedT1: 'zip_drop_t1', fieldT2: 'zip_pu_t2' },
                { filedT1: 'hotel_pu_t1', fieldT2: 'hotel_drop_t2' },
                { filedT1: 'hotel_drop_t1', fieldT2: 'hotel_pu_t2' },
                { filedT1: 'hotel_n_pu_t1', fieldT2: 'hotel_n_drop_t2' },
                { filedT1: 'hotel_n_drop_t1', fieldT2: 'hotel_n_pu_t2' },
                { filedT1: 'city_vol_pu_t1', fieldT2: 'city_vol_drop_t2' },
                { filedT1: 'city_vol_drop_t1', fieldT2: 'city_vol_pu_t2' }
            ];
            fieldReturn.forEach(element => {
                if(field.startsWith(element.filedT1))
                {
                    setReservationData((prev) => ({
                        ...prev,
                        [element.fieldT2] : value,
                    }));
                }
            })

        }



        validateReservation();

    };

// Construire les informations additionnelles
const additionalInfo = (t1t2 = "t1") => {
    let info = "";
    const nbLuggage = parseInt(reservationData.check_in_luggage) 
                    + parseInt(reservationData.cabin_bag)
                    + parseInt(reservationData.stroller_single) 
                    + parseInt(reservationData.stroller_double);

    if (reservationData[`pax_adult_${t1t2}`] > 0) {
        info += `Adults (+11 years old): ${reservationData[`pax_adult_${t1t2}`]}\n`;
    }
    if (reservationData[`pax_child_${t1t2}`] > 0) {
        info += `Children (3 to 11 years old): ${reservationData[`pax_child_${t1t2}`]}\n`;
    }
    if (reservationData[`pax_baby_${t1t2}`] > 0) {
        info += `Babies (-3 years old): ${reservationData[`pax_baby_${t1t2}`]}\n`;
    }

    if (nbLuggage > 0){
        info += "\n" + nbLuggage + " Luggage\n";
        if (reservationData.check_in_luggage > 0) {
            info += `Check-in luggage: ${reservationData.check_in_luggage}\n`;
        }
        if (reservationData.cabin_bag > 0) {
            info += `Cabin bag: ${reservationData.cabin_bag}\n`;
        }
        if (reservationData.stroller_single > 0) {
            info += `Single stroller: ${reservationData.stroller_single}\n`;
        }
        if (reservationData.stroller_double > 0) {
            info += `Double stroller: ${reservationData.stroller_double}\n`;
        }
    }

    return info.trim(); // Supprime les espaces inutiles
};

    const handleSubmit = async (event) => {
        event.preventDefault();

        const errors = validateReservation();
        if (errors.length > 0) {
            return false;
        }
        // if(!window.confirm("ENVOYER LE FORMULAIRE EST BON ?"))
        //     return false;

        // mise à jour du commentaire :
        // Mettre à jour `reservationData` avec les nouvelles infos
        const info_pax_luggage =  additionalInfo();
        setReservationData((prev) => {
            const updatedData = {
                ...prev,
                info_t1: prev.info_t1 + '\n' + info_pax_luggage,
                info_t2: prev.info_t2 + '\n' + info_pax_luggage,
            };

            // Attendre que React mette bien à jour l'état avant de continuer
            setTimeout(() => {
                // Store reservationData in LocalStorage
                localStorage.setItem('reservationData', JSON.stringify(updatedData));

        
                const form = document.createElement("form");
                form.method = "POST";
                form.action = confirmeResaPhp;
        
                // Add all form fields dynamically
                Object.keys(updatedData).forEach((key) => {
                    const input = document.createElement("input");
                    input.type = "hidden";
                    input.name = key;
                    input.value = updatedData[key];
                    form.appendChild(input);
                });

                console.log(form.action);
                        // Submit the form
                        document.body.appendChild(form);
                        form.submit();
            }, 100); // Petite pause pour attendre la mise à jour

            return updatedData;

        });
    };



    const handleBack = () => {
        window.history.back();
    };

    // Mise à jour du nombre total de passager
    useEffect(() => {
        const nb_pax = {
            adults: parseInt(reservationData.pax_adult_t1),
            children: parseInt(reservationData.pax_child_t1), 
            babies: parseInt(reservationData.pax_baby_t1), 
        };
        

        nb_pax.total = sommePax(nb_pax);
        
        setReservationData((prev) => ({
            ...prev,
            pax_t1: nb_pax.total,
            nb_pax: nb_pax,
        }));

        localStorage.setItem('reservationData', JSON.stringify(reservationData));

        let priceCalculated = null;
        if(reservationData.shuttle_private === "Shuttle")
        {
            if(shuttleData.length > 0)
            {
                priceCalculated = calculateShuttlePricesPax(shuttleData, from, to, nb_pax, reservationData.nb_trajet);
            }
            else
                console.log('shuttleData NUUUUUUUUUUUUUUUUUUUUUUUUL');
        }
        else
        {
            if(privateData.length > 0)
            {
                priceCalculated = calculatePrivatePricesPax(privateData, from, to, nb_pax, reservationData.nb_trajet);
            }
            else
                console.log('privateDate NUUUUUUUUUUUUUUUUUUUUUUUUL');
        }

        if(priceCalculated)
        {
            calculatePrice(priceCalculated); // Mise à jour des prix et des délais/duré
            // debugLogger.log({"PAX": priceCalculated });
        }
// console.log('FIN ON APPELLE calculateShuttlePricesPax Cest mieux nb_pax.total => ', nb_pax.total, pricePax);


        // setPricePax(pricePax);
    }, [reservationData.pax_adult_t1, reservationData.pax_child_t1, reservationData.pax_baby_t1]);

    return (
    <section id="reservation" className="py-5">
        <div className="container-fluid">
        <button onClick={handleBack}>Back</button>
            <h1 className="text-center mb-4">Book your transfer</h1>
            <div className="container-fluid">
            {/* 
            <p>queryParams = {queryParams}</p>
            <p>type_trajet = <b>{queryParams.get("type_trajet")}</b></p>
            <p>aller_retour : {JSON.stringify(reservationData.aller_retour)}</p>
            <p>Shutlle/Private = {reservationData.type}</p>
            <p>depart = {reservationData.depart}</p>
            <p>Arrive = {reservationData.arrive}</p>

            <p>shuttle_private = {JSON.stringify(storedData.shuttle_private)};</p>
            <p>storedData.shuttlePrices = {JSON.stringify(storedData[shuttlePrices])};</p>
            <p>shuttlePrices = {JSON.stringify(shuttlePrices)};</p>
            <p>storedData = {JSON.stringify(storedData)};</p>
            <p>privatePrices = {JSON.stringify(storedData.privatePrices)};</p>
            <p>reservationData : {JSON.stringify(reservationData)}</p>
            */}


            <form onSubmit={handleSubmit}>
                {/* User Information */}
                <div className="form-section airport-section">
                    <FormUser 
                        reservationData={reservationData} 
                        setReservationData={setReservationData} 
                        handleChange={handleChange} 
                        handlePhoneChange={handlePhoneChange} 
                        handleCountryChange={handleCountryChange}
                        fieldRefs={fieldRefs}
                    />
                </div>
<div className="row">
    <div className={reservationData.nb_trajet === 2 ? 'col-xl-6' : 'col-12'}>


                 {/* First Step */}
                 <div className="form-section airport-section">
                    <div className="row">
                        <div className="col-12">
                            <h2 className="bg-black card-title mb-4 p-2 rounded text-center text-jaune">FIRST STEP {reservationData.french_date_pu_t1 ||""}</h2>
                        </div>
                        <div className="col-12 d-flex justify-content-center">
                        <DatePicker
                            selected={
                                reservationData[`date_jour_pu_t1`] &&
                                reservationData[`date_mois_pu_t1`] &&
                                reservationData[`date_annee_pu_t1`]
                                    ? new Date(
                                        reservationData[`date_annee_pu_t1`],
                                        reservationData[`date_mois_pu_t1`] - 1,
                                        reservationData[`date_jour_pu_t1`]
                                    )
                                    : null
                            }
                            onChange={(date) => handleDateChange("t1", date)}
                            dateFormat="dd/MM/yyyy"
                            minDate={addDays(new Date(),1)}
                            maxDate={addYears(new Date(), 3)}
                            placeholderText="Select departure date required"
                            className="form-control"
                            required
                            customInput={
                                <div className="custom-date-picker">
                                    <FontAwesomeIcon icon={faCalendarAlt} className="calendar-icon" />
                                    <input
                                        ref={fieldRefs.french_date_pu_t1}
                                        type="text"
                                        placeholder="Select departure date required"
                                        readOnly
                                        className="form-control"
                                        required
                                        value={reservationData[`french_date_pu_t1`] || ""}
                                    />
                                </div>
                            }
                        />

                        </div>

                        <div className="col-lg-6">
                            {/* 1 = airport */}
                            {parseInt(reservationData.type_pu_t1) === 1 ? (
                                <FormAirport trajet="t1" type="pu" reservationData={reservationData} handleChange={handleChange} fieldRefs={fieldRefs} getMinMaxTime={getMinMaxTime} />
                            ) : (
                                <FormAddress trajet="t1" type="pu" reservationData={reservationData} handleChange={handleChange} fieldRefs={fieldRefs} />
                            )}
                                
                        </div>
                        {/* <div className="col-lg-1 d-flex align-items-center justify-content-center">

                        <div className="flight-arrow">➔</div>
                        </div> */}

                        {/* Type d'arrivée */}
                        <div className="col-lg-6">
                            {/* 1 = airport */}
                            {parseInt(reservationData.type_drop_t1) === 1 ? (
                                <FormAirport trajet="t1" type="drop" reservationData={reservationData} handleChange={handleChange} fieldRefs={fieldRefs} getMinMaxTime={getMinMaxTime} />

                            ) : (
                                <FormAddress trajet="t1" type="drop" reservationData={reservationData} handleChange={handleChange} fieldRefs={fieldRefs} />
                            )}
                        </div>
                    </div>
                    <div className="col-12">

                    <label>
                        Additional Info:
                        <textarea
                            ref={fieldRefs.info_t1}
                            value={reservationData?.[`info_t1`] || ""}
                            id={`info_t1`}
                            onChange={handleChange}
                            placeholder="Enter additional information T1"
                        ></textarea>
                    </label>
                    </div>
                </div>
                </div>
    <div className="col-xl-6">
                {/* RoundTrip: retour dynamique */}
                {parseInt(reservationData.aller_retour) === 2 && (
                    <div className="form-section address-section">
                        <div className="row">
                            <div className="col-12">
                                <h2 className="bg-black card-title mb-4 p-2 rounded text-center text-jaune">RETURN - SECOND STEP {reservationData.french_date_pu_t2 ||""}</h2>
                            </div>
                            <div className="col-12 d-flex justify-content-center">
                            <DatePicker
                                selected={
                                    reservationData.date_jour_pu_t2 &&
                                    reservationData.date_mois_pu_t2 &&
                                    reservationData.date_annee_pu_t2
                                        ? new Date(
                                            reservationData.date_annee_pu_t2,
                                            reservationData.date_mois_pu_t2 - 1,
                                            reservationData.date_jour_pu_t2
                                        )
                                        : null
                                }
                                onChange={(date) => handleDateChange("t2", date)}
                                dateFormat="dd/MM/yyyy"
                                minDate={addDays(new Date(), 1)}
                                maxDate={addYears(new Date(), 2)}
                                placeholderText="Select return date"
                                className="form-control"
                                customInput={
                                    <div className="custom-date-picker">
                                        <FontAwesomeIcon icon={faCalendarAlt} className="calendar-icon" />
                                        <input
                                            ref={fieldRefs.french_date_pu_t2}
                                            type="text"
                                            placeholder="Select return date"
                                            readOnly
                                            className="form-control"
                                            value={
                                            reservationData.date_jour_pu_t2 &&
                                            reservationData.date_mois_pu_t2 &&
                                            reservationData.date_annee_pu_t2
                                                ? `${String(reservationData.date_jour_pu_t2).padStart(2, "0")}/${
                                                    String(reservationData.date_mois_pu_t2).padStart(2, "0")
                                                }/${reservationData.date_annee_pu_t2}`
                                                : ""
                                        }
                                        />
                                    </div>
                                }
                            />
                            </div>
                        

                       {/* 1 = airport */}
                       <div className="col-lg-6">
                        {parseInt(reservationData.type_pu_t2) === 1 ? (
                                <FormAirport trajet="t2" type="pu" reservationData={reservationData} handleChange={handleChange} fieldRefs={fieldRefs} getMinMaxTime={getMinMaxTime} />

                            ) : (
                                <FormAddress trajet="t2" type="pu" reservationData={reservationData} handleChange={handleChange} fieldRefs={fieldRefs} />
                            )}
                        </div>
{/*                         
                        <div className="col-lg-1 d-blex align-items-center justify-content-center">
                            <div className="flight-arrow">➔</div>
                        </div> */}
                        
                        <div className="col-lg-6">
                            {/* 1 = airport */}
                            {parseInt(reservationData.type_drop_t2) === 1 ? (
                                <FormAirport trajet="t2" type="drop" reservationData={reservationData} handleChange={handleChange} fieldRefs={fieldRefs} getMinMaxTime={getMinMaxTime} />

                            ) : (
                                <FormAddress trajet="t2" type="drop" reservationData={reservationData} handleChange={handleChange} fieldRefs={fieldRefs} />
                            )}  
                        </div>
                    <div className="col-12">
                        <label>
                            Additional Info:
                            <textarea
                                ref={fieldRefs.info_t2}
                                value={reservationData?.[`info_t2`] || ""}
                                id={`info_t2`}
                                onChange={handleChange}
                                placeholder="Enter additional information T2"
                            ></textarea>
                        </label>
                    </div>
                     
                     
                    
                </div>
                </div>
                )}
                <div className="col-12">
                    <input
                        type="hidden"
                        ref={fieldRefs.info_pax_luggage}
                        value={reservationData?.[`info_pax_luggage`] || ""}
                        id={`info_pax_luggage`}
                    />
                    </div>
    </div>
    </div>
                {/* Bouton de soumission */}
                {/* Footer */}


                <div className="form-section error-section">
    <div className="bg-body form-footer p-2 rounded">
        <button type="submit" className="btn btn-dark">Book Now</button>


        {errorBookingFields.length > 0 && (
            <div className="row">
                <div className="col-12">
                    <div className="py-5">
                        <h3>Errors</h3>
                        <ul className="p-3 rounded text-bg-danger list-unstyled">
                            {errorBookingFields.map(({ message, fieldId }, id) => (
                                <li
                                    key={id}
                                    onClick={() => {
                                        const field = fieldRefs[fieldId]?.current;
                                        // console.log(field);
                                        // alert(field);
                                        // alert(field.setFocus());
                                        if (field) {
                                            if (typeof field.focus === "function") {
                                                //  debugLogger.log('Focus normal pour les <input>, <select>, etc ' + field);
                                                // debugLogger.log(field);
                                                field.focus(); // Focus normal pour les <input>, <select>, etc.
                                            } else if (typeof field.setFocus === "function") {
                                                // debugLogger.log(field);
                                                // debugLogger.log('Pour DatePicker et composants React ' + field);
                                                // console.log("Pour DatePicker et composants React " + field + " " + field.focus + ' fieldId=' + fieldId);
                                                field.setFocus(); // Pour DatePicker et composants React
                                            }
                                            field.scrollIntoView?.({ behavior: "smooth", block: "center" });
                                        }
                                    }}
                                    style={{ cursor: "pointer" }}
                                    dangerouslySetInnerHTML={{ __html: `${message}` }}
                                />
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
        )}
    </div>
</div>


            </form>
        </div>


        </div>
    </section>
    );
};

export default ReservationForm;
